import { Controller } from '@hotwired/stimulus';
import { ClipperMap } from '../../components/modern/clipper_maps/clipper_map';

const MAP_URL = 'https://maps.googleapis.com/maps/api/js?v=3.exp&key=';

// Connects to data-controller="maps--transit-cards-map"
export default class extends Controller {
  static values = {
    locations: Array,
    googleKey: String
  }

  connect() {
    if (document.googleMapLib) {
      this.initializeMap();
    } else {
      this.loadGoogleMaps();
    }
  }

  loadGoogleMaps(){
    const script = document.createElement('script');
    script.src = `${MAP_URL}${this.googleKeyValue}&libraries=places`;
    script.async = true;
    script.onload = () => {
      document.googleMapLib = true;
      this.initializeMap();
    };
    document.head.appendChild(script);
  }

  initializeMap() {
    new ClipperMap(this.element, this.locationsValue);
  }
}
